import type {PublicMethodUtils} from '@wix/document-services-types'
import type {MobileAlgoPublicAPI} from '@wix/document-services-public-types'
import _ from 'lodash'
import {responsify} from '@wix/document-services-implementation'
import type {PublicModuleDeclaration} from '../../documentServicesInitialisation'

export default function (publicMethodUtils: PublicMethodUtils): PublicModuleDeclaration<MobileAlgoPublicAPI> {
    const {
        extensionPublicAPI: {dataManipulation, getter}
    } = publicMethodUtils
    return {
        methods: {
            mobileAlgo: {
                groupings: {
                    removeLastGroupingHashFromAllPages: dataManipulation(
                        'mobileAlgo.groupings.removeLastGroupingHashFromAllPages'
                    ),
                    removeLastGroupingHashFromPage: dataManipulation(
                        'mobileAlgo.groupings.removeLastGroupingHashFromPage'
                    ),
                    removeLastGroupingHashFromSection: dataManipulation(
                        'mobileAlgo.groupings.removeLastGroupingHashFromSection'
                    ),
                    getLastGroupingHash: getter('mobileAlgo.groupings.getLastGroupingHash')
                },
                run: publicMethodUtils.defineDataManipulationAction(_.noop, {
                    asyncPreDataManipulation: responsify.run,
                    isAsyncOperation: true,
                    noBatching: true
                }),
                runForPage: publicMethodUtils.defineDataManipulationAction(_.noop, {
                    asyncPreDataManipulation: responsify.runForPage,
                    isAsyncOperation: true,
                    noBatching: true
                }),
                runForAllPages: publicMethodUtils.defineDataManipulationAction(_.noop, {
                    asyncPreDataManipulation: responsify.runForAllPages,
                    isAsyncOperation: true,
                    noBatching: true
                }),
                locking: {
                    is: {
                        componentLocked: getter('mobileAlgo.locking.isComponentLocked')
                    },
                    unlockSection: dataManipulation('mobileAlgo.locking.unlockSection'),
                    unlockSectionsForAllPages: dataManipulation('mobileAlgo.locking.unlockSectionsForAllPages'),
                    unlockSectionsForPage: dataManipulation('mobileAlgo.locking.unlockSectionsForPage'),
                    lockSection: dataManipulation('mobileAlgo.locking.lockSection'),
                    lockSectionsForPage: dataManipulation('mobileAlgo.locking.lockSectionsForPage'),
                    lockSectionsForAllPages: dataManipulation('mobileAlgo.locking.lockSectionsForAllPages'),
                    softLock: publicMethodUtils.defineDataManipulationAction(_.noop, {
                        asyncPreDataManipulation: responsify.locking.softLock,
                        isAsyncOperation: true
                    }),
                    softLockPage: publicMethodUtils.defineDataManipulationAction(_.noop, {
                        asyncPreDataManipulation: responsify.locking.softLockPage,
                        isAsyncOperation: true
                    }),
                    removeExecutionLocks: dataManipulation('mobileAlgo.locking.removeExecutionLocks'),
                    removeExecutionLocksForPage: dataManipulation('mobileAlgo.locking.removeExecutionLocksForPage'),
                    removeExecutionLocksForAllPages: dataManipulation(
                        'mobileAlgo.locking.removeExecutionLocksForAllPages'
                    )
                },
                enable: dataManipulation('mobileAlgo.settings.enable'),
                disable: dataManipulation('mobileAlgo.settings.disable'),
                is: {
                    enabled: getter('mobileAlgo.settings.isEnabled')
                },
                utils: {
                    getFontSize: getter('mobileAlgo.utils.getFontSize')
                }
            }
        }
    }
}
